<script lang="ts">
  import clsx from 'clsx'
  import type { Snippet } from 'svelte'

  type Props = {
    class?: string
    children: Snippet
  }

  let { class: className = '', children }: Props = $props()
</script>

<div
  class={clsx(
    'absolute top-0 left-0 w-full h-full flex items-center justify-center p-4',
    className,
  )}
>
  <p>{@render children?.()}</p>
</div>
